import { observer } from 'mobx-react';
import { ProductLicenseResource } from '../../../../../../../Types';
import LearningDesignExperienceStore from '../../../../../../Experience/Store';
import { ExperienceResource } from '../../../../ExperienceCatalog/Types';
import SelectableDate from './SelectableDate';

export interface Props {
  experienceResource: ExperienceResource;
  experienceStore: LearningDesignExperienceStore;
  productLicense: ProductLicenseResource;
}

function SelectableDates({ experienceResource, experienceStore, productLicense }: Props) {
  return (
    <div>
      {experienceResource.payload.programInstanceOptions.scheduled.map((scheduledOption) => (
        <SelectableDate
          scheduledOption={scheduledOption}
          experienceStore={experienceStore}
          key={scheduledOption.id}
          productLicense={productLicense}
        />
      ))}
    </div>
  );
}

export default observer(SelectableDates);
